<template>
  <div class="movie-block placeholder-wave">
    <div class="movie-block__poster">
      <div class="movie-poster">
        <div class="movie-poster__image">
          <div class="ratio ratio-poster">
            <span class="placeholder col-12 h-100 d-block placeholder-lg"></span>
          </div>
        </div>
      </div>
    </div>

    <div class="movie-block__content">
      <div>
        <h2 class="h3 d-flex flex-wrap gap-1">
          <span
            class="placeholder placeholder-lg"
            v-for="n in randomCount(1, 3)"
            :key="n"
            :class="`col-${randomCount(3, 8)}`"
          ></span>
        </h2>
      </div>

      <h3 class="h4 d-flex flex-wrap gap-1">
        <span
          class="placeholder placeholder-md"
          v-for="n in randomCount(1, 3)"
          :key="n"
          :class="`col-${randomCount(3, 8)}`"
        ></span>
      </h3>

      <p>
        <span
          class="placeholder placeholder-sm mb-1 d-flex flex-wrap gap-1"
          :class="`col-${randomCount(3, 12)}`"
          v-for="n in randomCount(1, 3)"
          :key="n"
        ></span>
      </p>
    </div>

    <div class="movie-block__timetable">
      <div class="placeholder placeholder-lg mb-3" :class="`col-${randomCount(3, 12)}`"></div>
      <div class="row g-1">
        <div class="col d-flex flex-column gap-1" v-for="n in 4" :key="n">
          <span
            v-for="n in randomCount(3, 4)"
            :key="n"
            class="placeholder placeholder-button col-12"
          ></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// No props needed - this is a static skeleton component
const randomCount = (min = 2, max = 4) => Math.floor(Math.random() * (max - min + 1)) + min;
</script>

<style scoped>
.movie-block__poster .placeholder {
  border-radius: 0;
}

.placeholder {
  vertical-align: middle;
}
</style>
